import { ComputedRef } from 'vue'

import { Incident } from '@collector/sportsapi-client'
import { useEventIncidentsQueue } from '@desktop/views/Relation/Sports/composables'

import { useHistoryIncidentParticipantSettings } from './useHistoryIncidentParticipantSettings'
import {
  SubParticipantSettings,
  useSubParticipantAvailability,
} from './useSubParticipantAvailability'

export function useHistoryIncidentSubParticipantAvailability(
  incident: Incident,
): {
  incidentParticipantSettings: ComputedRef<SubParticipantSettings>
  incidentAssistantSettings: ComputedRef<SubParticipantSettings>
  incidentSecondaryAssistantSettings: ComputedRef<SubParticipantSettings>
  showParticipantSelect: ComputedRef<boolean>
  showAssistantSelect: ComputedRef<boolean>
  showSecondaryAssistantSelect: ComputedRef<boolean>
} {
  // composables
  const eventIncidentsQueue = useEventIncidentsQueue()
  const { getSubParticipantSettings } =
    useHistoryIncidentParticipantSettings(incident)

  const participant = useSubParticipantAvailability(
    incident,
    'participant',
    getSubParticipantSettings,
    eventIncidentsQueue,
  )
  const assistant = useSubParticipantAvailability(
    incident,
    'assistant',
    getSubParticipantSettings,
    eventIncidentsQueue,
  )
  const secondaryAssistant = useSubParticipantAvailability(
    incident,
    'secondary_assistant',
    getSubParticipantSettings,
    eventIncidentsQueue,
  )

  return {
    incidentParticipantSettings: participant.settings,
    incidentAssistantSettings: assistant.settings,
    incidentSecondaryAssistantSettings: secondaryAssistant.settings,
    showParticipantSelect: participant.showSelect,
    showAssistantSelect: assistant.showSelect,
    showSecondaryAssistantSelect: secondaryAssistant.showSelect,
  }
}
